import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { heightConverter, ftToCm, inToCm, ftInToMCm, lbToKG, kgToLb, mToIn, cmToIn } from "Helpers/util";
import React, { memo, useEffect, useState } from "react";
import CustomHeight from "Root/quiz/elements/InputHeightElement/CustomHeight";
import WeightComponent from "Root/quiz/elements/InputWeightElement/weight";
const HeightAndWeight = (props) => {
    const getDefaultValues = () => {
        if (props.prevAnswer) {
            const values = props.prevAnswer.split(",").filter((elem) => elem !== ",");
            const inches = parseInt(values[1], 10);
            const calculatedFeet = parseInt((inches / 12).toString(), 10);
            const calculatedInches = inches % 12;
            const [ft, inch] = [calculatedFeet, calculatedInches];
            const [m, cm] = ftInToMCm(ft, inch);
            const kg = lbToKG(values[0]);
            return {
                weight: values[0].toString(),
                weightKg: kg.toString(),
                height: { ft: ft.toString(), in: inch.toString(), m: m.toString(), cm: cm.toString() },
            };
        }
        return { weight: "", weightKg: "", height: { ft: "", in: "", m: "", cm: "" } };
    };
    const [answer, setAnswer] = useState(getDefaultValues());
    const handleWeightInput = (e) => {
        setAnswer((prevState) => ({
            ...prevState,
            weight: e,
            weightKg: lbToKG(e).toString(),
        }));
    };
    const handleWeightKgInput = (e) => {
        setAnswer((prevState) => ({
            ...prevState,
            weightKg: e,
            weight: kgToLb(e).toString(),
        }));
    };
    const ftInput = (e) => {
        const cmFt = ftToCm(e);
        const cmIn = inToCm(answer.height.in);
        const totalCm = cmFt + cmIn;
        const m = Math.floor(totalCm / 100);
        const cm = Math.floor(totalCm - m * 100);
        setAnswer((prevState) => ({
            ...prevState,
            height: {
                ...answer.height,
                ft: e,
                m: m.toString(),
                cm: cm.toString(),
            },
        }));
    };
    const inInput = (e) => {
        const cmFt = ftToCm(answer.height.ft);
        const cmIn = inToCm(e);
        const totalCm = cmFt + cmIn;
        const m = Math.floor(totalCm / 100);
        const cm = Math.floor(totalCm - m * 100);
        setAnswer((prevState) => ({
            ...prevState,
            height: {
                ...answer.height,
                in: e,
                m: m.toString(),
                cm: cm.toString(),
            },
        }));
    };
    const mInput = (e) => {
        const mIn = mToIn(e);
        const cmIn = cmToIn(answer.height.cm);
        const totalIn = mIn + cmIn;
        const realFeet = Math.floor(totalIn / 12);
        const realInches = Math.floor(totalIn - realFeet * 12);
        setAnswer((prevState) => ({
            ...prevState,
            height: {
                ...answer.height,
                m: e,
                ft: realFeet.toString(),
                in: realInches.toString(),
            },
        }));
    };
    const cmInput = (e) => {
        const mIn = mToIn(answer.height.m);
        const cmIn = cmToIn(e);
        const totalIn = mIn + cmIn;
        const realFeet = Math.floor(totalIn / 12);
        const realInches = Math.floor(totalIn - realFeet * 12);
        setAnswer((prevState) => ({
            ...prevState,
            height: {
                ...answer.height,
                cm: e,
                ft: realFeet.toString(),
                in: realInches.toString(),
            },
        }));
    };
    useEffect(() => {
        const ft = Number(answer.height.ft);
        const inc = Number(answer.height.in);
        if (!Number.isNaN(ft) && !Number.isNaN(inc)) {
            props.setValue([answer.weight, heightConverter(ft.toString(), inc.toString()).toString()]);
        }
    }, [answer]);
    return (_jsxs(_Fragment, { children: [_jsx(WeightComponent, { setValue: props.metrics ? handleWeightKgInput : handleWeightInput, value: props.metrics ? answer.weightKg : answer.weight, metrics: props.metrics, setMetrics: props.setMetrics, hideMetrics: props.hideMetrics }), _jsx(CustomHeight, { ft: answer.height.ft, in: answer.height.in, m: answer.height.m, cm: answer.height.cm, mInput: mInput, cmInput: cmInput, ftInput: ftInput, inInput: inInput, metrics: props.metrics })] }));
};
export default memo(HeightAndWeight);
